import { useTranslation } from 'react-i18next';

// Import utilities
import { DrawerRPC, useFavourites } from 'components/utilities';

// Import icons
import { ReactComponent as FavouriteIcon } from 'assets/icons/ic_favourite.svg';

// Import components
import Favourite from './Favourite';
import { Button } from 'components/elements';
import useToggle from 'components/utilities/hooks/toggle/useToggle';

export const Favourites = () => {
	const { t } = useTranslation();
	const [open, toggle] = useToggle();
	const { filteredfavourites, onDeleteFavourites } = useFavourites();

	return (
		<>
			<Button modifiers={['navIcon']} onClick={toggle}>
				<FavouriteIcon />
			</Button>

			<DrawerRPC isOpen={open} onClose={toggle} title={t('common_favourites_title')}>
				{filteredfavourites.map((item) => (
					<Favourite toggle={toggle} key={item.uuid} item={item} deleteFavourite={onDeleteFavourites} />
				))}
			</DrawerRPC>
		</>
	);
};
